import * as regionApi from '../common/api/region';
import { NOT_FOUND, INTERNAL_SERVER_ERROR } from './status';

export const CLEAR_SUBREGION_OVERVIEW_DATA = 'CLEAR_SUBREGION_OVERVIEW_DATA';
export const FETCH_SUBREGION_OVERVIEW_DATA = 'FETCH_SUBREGION_OVERVIEW_DATA';
export const FETCH_SUBREGION_OVERVIEW_DATA_SUCCESS = 'FETCH_SUBREGION_OVERVIEW_DATA_SUCCESS';

export const FETCH_REGIONAL_ARTICLES = 'FETCH_REGIONAL_ARTICLES';
export const FETCH_REGIONAL_ARTICLES_SUCCESS = 'FETCH_REGIONAL_ARTICLES_SUCCESS';
export const FETCH_REGIONAL_ARTICLES_FAILURE = 'FETCH_REGIONAL_ARTICLES_FAILURE';

export const fetchOverviewData = subregionId => async (dispatch) => {
  dispatch({
    type: FETCH_SUBREGION_OVERVIEW_DATA,
    subregionId,
  });

  try {
    const overview = await regionApi.fetchRegionalOverview(subregionId);

    dispatch({
      type: FETCH_SUBREGION_OVERVIEW_DATA_SUCCESS,
      subregionId,
      overview,
    });
  } catch (err) {
    if (400 <= err.statusCode && err.statusCode < 500) {
      dispatch({
        type: NOT_FOUND,
        message: 'The Regional Forecast Overview could not be found',
      });
    } else {
      dispatch({
        type: INTERNAL_SERVER_ERROR,
        message: 'The server could not return the Regional Forecast Overview',
      });
    }
  }
};

export const clearOverviewData = () => ({
  type: CLEAR_SUBREGION_OVERVIEW_DATA,
});

export const fetchRegionalArticles = subregionId => async (dispatch) => {
  dispatch({
    type: FETCH_REGIONAL_ARTICLES,
  });

  try {
    const { data } = await regionApi.fetchRegionalArticles(subregionId);
    dispatch({
      type: FETCH_REGIONAL_ARTICLES_SUCCESS,
      articles: data.regional,
    });
  } catch (error) {
    dispatch({
      type: FETCH_REGIONAL_ARTICLES_FAILURE,
      error,
    });
  }
};



// WEBPACK FOOTER //
// ./src/actions/subregion.js